<template>
    <vx-tabs v-model="tabValue" size="sm">
        <vx-tab value="no">
            <font-awesome-icon :icon="faTimes" />
        </vx-tab>
        <vx-tab value="unset"> <font-awesome-icon :icon="faMinus" /> </vx-tab
        ><vx-tab value="yes">
            <font-awesome-icon :icon="faCheck" />
        </vx-tab>
    </vx-tabs>
</template>

<script lang="ts" setup>
import { faCheck, faMinus, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxTabs, VxTab } from '@voxie/frontend-components';
import { computed } from 'vue';

const model = defineModel<boolean | undefined>({ required: true });

const tabValue = computed<'no' | 'unset' | 'yes'>({
    set: (value) => {
        if (value === 'no') {
            model.value = false;
        } else if (value === 'yes') {
            model.value = true;
        } else {
            model.value = undefined;
        }
    },
    get: () => {
        if (model.value === true) {
            return 'yes';
        }

        if (model.value === false) {
            return 'no';
        }

        return 'unset';
    },
});
</script>
